// Static make/model data for vehicle search dropdowns.
// MarketCheck API is case-insensitive, so title case works fine.
// Values here match MarketCheck's inventory data.

const vehicleData = {
  Acura: ['ILX', 'Integra', 'MDX', 'RDX', 'RLX', 'TLX', 'ZDX'],
  'Alfa Romeo': ['Giulia', 'Stelvio', 'Tonale'],
  Audi: ['A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'e-tron', 'e-tron GT', 'e-tron S', 'Q3', 'Q4 e-tron', 'Q5', 'Q7', 'Q8', 'Q8 e-tron', 'RS3', 'RS5', 'RS6', 'RS7', 'S3', 'S4', 'S5', 'S6', 'S7', 'SQ5', 'SQ7', 'SQ8', 'TT'],
  BMW: ['2 Series', '3 Series', '4 Series', '5 Series', '7 Series', '8 Series', 'i4', 'i5', 'i7', 'iX', 'M2', 'M3', 'M4', 'M5', 'M8', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7', 'XM', 'Z4'],
  Buick: ['Enclave', 'Encore', 'Encore GX', 'Envision', 'Envista'],
  Cadillac: ['CT4', 'CT5', 'Escalade', 'Escalade-V', 'Lyriq', 'XT4', 'XT5', 'XT6'],
  Chevrolet: ['Blazer', 'Blazer EV', 'Bolt EV', 'Bolt EUV', 'Camaro', 'Colorado', 'Corvette', 'Equinox', 'Equinox EV', 'Express', 'Impala', 'Malibu', 'Silverado 1500', 'Silverado 2500HD', 'Silverado 3500HD', 'Silverado EV', 'Spark', 'Suburban', 'Tahoe', 'Trailblazer', 'Traverse', 'Trax'],
  Chrysler: ['300', 'Pacifica', 'Voyager'],
  Dodge: ['Challenger', 'Charger', 'Durango', 'Grand Caravan', 'Hornet'],
  FIAT: ['500', '500X'],
  Ford: ['Bronco', 'Bronco Sport', 'E-Transit', 'EcoSport', 'Edge', 'Escape', 'Expedition', 'Explorer', 'F-150', 'F-150 Lightning', 'F-250', 'F-350', 'Flex', 'Maverick', 'Mustang', 'Mustang Mach-E', 'Ranger', 'Transit', 'Transit Connect'],
  Genesis: ['Electrified G80', 'Electrified GV70', 'G70', 'G80', 'G90', 'GV60', 'GV70', 'GV80'],
  GMC: ['Acadia', 'Canyon', 'Hummer EV', 'Sierra 1500', 'Sierra 2500HD', 'Sierra 3500HD', 'Terrain', 'Yukon', 'Yukon XL'],
  Honda: ['Accord', 'Civic', 'CR-V', 'HR-V', 'Odyssey', 'Passport', 'Pilot', 'Prologue', 'Ridgeline'],
  Hyundai: ['Elantra', 'Ioniq 5', 'Ioniq 6', 'Kona', 'Kona Electric', 'Nexo', 'Palisade', 'Santa Cruz', 'Santa Fe', 'Sonata', 'Tucson', 'Venue'],
  Infiniti: ['Q50', 'Q60', 'QX50', 'QX55', 'QX60', 'QX80'],
  Jaguar: ['E-Pace', 'F-Pace', 'F-Type', 'I-Pace', 'XE', 'XF'],
  Jeep: ['Cherokee', 'Compass', 'Gladiator', 'Grand Cherokee', 'Grand Cherokee 4xe', 'Grand Cherokee L', 'Grand Wagoneer', 'Renegade', 'Wagoneer', 'Wrangler', 'Wrangler 4xe'],
  Kia: ['Carnival', 'EV6', 'EV9', 'Forte', 'K5', 'Niro', 'Niro EV', 'Rio', 'Seltos', 'Sorento', 'Soul', 'Sportage', 'Stinger', 'Telluride'],
  'Land Rover': ['Defender', 'Discovery', 'Discovery Sport', 'Range Rover', 'Range Rover Evoque', 'Range Rover Sport', 'Range Rover Velar'],
  Lexus: ['ES', 'GX', 'IS', 'LC', 'LS', 'LX', 'NX', 'RC', 'RX', 'RZ', 'TX', 'UX'],
  Lincoln: ['Aviator', 'Corsair', 'Nautilus', 'Navigator'],
  Lucid: ['Air'],
  Maserati: ['Ghibli', 'GranTurismo', 'Grecale', 'Levante', 'Quattroporte'],
  Mazda: ['CX-30', 'CX-5', 'CX-50', 'CX-70', 'CX-90', 'Mazda3', 'MX-5 Miata', 'MX-30'],
  'Mercedes-Benz': ['A-Class', 'AMG GT', 'C-Class', 'CLA', 'CLE', 'E-Class', 'EQB', 'EQE', 'EQS', 'G-Class', 'GLA', 'GLB', 'GLC', 'GLE', 'GLS', 'S-Class', 'SL'],
  MINI: ['Clubman', 'Convertible', 'Countryman', 'Hardtop'],
  Mitsubishi: ['Eclipse Cross', 'Mirage', 'Outlander', 'Outlander PHEV', 'Outlander Sport'],
  Nissan: ['Altima', 'Ariya', 'Armada', 'Frontier', 'Kicks', 'Leaf', 'Maxima', 'Murano', 'Pathfinder', 'Rogue', 'Sentra', 'Titan', 'Versa', 'Z'],
  Polestar: ['Polestar 2'],
  Porsche: ['718 Boxster', '718 Cayman', '911', 'Cayenne', 'Macan', 'Panamera', 'Taycan'],
  RAM: ['1500', '2500', '3500', 'ProMaster'],
  Rivian: ['R1S', 'R1T'],
  Subaru: ['Ascent', 'BRZ', 'Crosstrek', 'Forester', 'Impreza', 'Legacy', 'Outback', 'Solterra', 'WRX'],
  Tesla: ['Model 3', 'Model S', 'Model X', 'Model Y'],
  Toyota: ['4Runner', 'bZ4X', 'Camry', 'Corolla', 'Corolla Cross', 'Crown', 'GR Corolla', 'GR Supra', 'GR86', 'Grand Highlander', 'Highlander', 'Land Cruiser', 'Mirai', 'Prius', 'Prius Prime', 'RAV4', 'RAV4 Prime', 'Sequoia', 'Sienna', 'Tacoma', 'Tundra', 'Venza'],
  Volkswagen: ['Arteon', 'Atlas', 'Atlas Cross Sport', 'Golf', 'Golf GTI', 'Golf R', 'ID.4', 'ID.Buzz', 'Jetta', 'Jetta GLI', 'Taos', 'Tiguan'],
  Volvo: ['C40 Recharge', 'EX30', 'EX90', 'S60', 'S90', 'V60', 'V90', 'XC40', 'XC40 Recharge', 'XC60', 'XC90'],
};

// Body types applicable to each model.
// Models not listed here show all body types (safe fallback).
// Models with multiple body types (e.g., Camaro: Coupe + Convertible) list all.
const modelBodyTypes = {
  // Acura
  'ILX': ['Sedan'], 'Integra': ['Hatchback'], 'MDX': ['SUV'], 'RDX': ['SUV'],
  'RLX': ['Sedan'], 'TLX': ['Sedan'], 'ZDX': ['SUV'],
  // Alfa Romeo
  'Giulia': ['Sedan'], 'Stelvio': ['SUV'], 'Tonale': ['SUV'],
  // Audi
  'A3': ['Sedan'], 'A4': ['Sedan'], 'A5': ['Coupe', 'Convertible'], 'A6': ['Sedan'],
  'A7': ['Sedan'], 'A8': ['Sedan'], 'e-tron': ['SUV'], 'e-tron GT': ['Sedan'],
  'e-tron S': ['SUV'], 'Q3': ['SUV'], 'Q4 e-tron': ['SUV'], 'Q5': ['SUV'],
  'Q7': ['SUV'], 'Q8': ['SUV'], 'Q8 e-tron': ['SUV'], 'RS3': ['Sedan'],
  'RS5': ['Coupe'], 'RS6': ['Wagon'], 'RS7': ['Sedan'], 'S3': ['Sedan'],
  'S4': ['Sedan'], 'S5': ['Coupe'], 'S6': ['Sedan'], 'S7': ['Sedan'],
  'SQ5': ['SUV'], 'SQ7': ['SUV'], 'SQ8': ['SUV'], 'TT': ['Coupe', 'Convertible'],
  // BMW
  '2 Series': ['Coupe'], '3 Series': ['Sedan'], '4 Series': ['Coupe', 'Convertible'],
  '5 Series': ['Sedan'], '7 Series': ['Sedan'], '8 Series': ['Coupe', 'Convertible'],
  'i4': ['Sedan'], 'i5': ['Sedan'], 'i7': ['Sedan'], 'iX': ['SUV'],
  'M2': ['Coupe'], 'M3': ['Sedan'], 'M4': ['Coupe', 'Convertible'], 'M5': ['Sedan'],
  'M8': ['Coupe', 'Convertible'], 'X1': ['SUV'], 'X2': ['SUV'], 'X3': ['SUV'],
  'X4': ['SUV'], 'X5': ['SUV'], 'X6': ['SUV'], 'X7': ['SUV'], 'XM': ['SUV'],
  'Z4': ['Convertible'],
  // Buick
  'Enclave': ['SUV'], 'Encore': ['SUV'], 'Encore GX': ['SUV'],
  'Envision': ['SUV'], 'Envista': ['SUV'],
  // Cadillac
  'CT4': ['Sedan'], 'CT5': ['Sedan'], 'Escalade': ['SUV'], 'Escalade-V': ['SUV'],
  'Lyriq': ['SUV'], 'XT4': ['SUV'], 'XT5': ['SUV'], 'XT6': ['SUV'],
  // Chevrolet
  'Blazer': ['SUV'], 'Blazer EV': ['SUV'], 'Bolt EV': ['Hatchback'],
  'Bolt EUV': ['Hatchback'], 'Camaro': ['Coupe', 'Convertible'], 'Colorado': ['Truck'],
  'Corvette': ['Coupe', 'Convertible'], 'Equinox': ['SUV'], 'Equinox EV': ['SUV'],
  'Express': ['Van'], 'Impala': ['Sedan'], 'Malibu': ['Sedan'],
  'Silverado 1500': ['Truck'], 'Silverado 2500HD': ['Truck'], 'Silverado 3500HD': ['Truck'],
  'Silverado EV': ['Truck'], 'Spark': ['Hatchback'], 'Suburban': ['SUV'],
  'Tahoe': ['SUV'], 'Trailblazer': ['SUV'], 'Traverse': ['SUV'], 'Trax': ['SUV'],
  // Chrysler
  '300': ['Sedan'], 'Pacifica': ['Minivan'], 'Voyager': ['Minivan'],
  // Dodge
  'Challenger': ['Coupe'], 'Charger': ['Sedan'], 'Durango': ['SUV'],
  'Grand Caravan': ['Minivan'], 'Hornet': ['SUV'],
  // FIAT
  '500': ['Hatchback'], '500X': ['SUV'],
  // Ford
  'Bronco': ['SUV'], 'Bronco Sport': ['SUV'], 'E-Transit': ['Van'],
  'EcoSport': ['SUV'], 'Edge': ['SUV'], 'Escape': ['SUV'],
  'Expedition': ['SUV'], 'Explorer': ['SUV'], 'F-150': ['Truck'],
  'F-150 Lightning': ['Truck'], 'F-250': ['Truck'], 'F-350': ['Truck'],
  'Flex': ['SUV'], 'Maverick': ['Truck'], 'Mustang': ['Coupe', 'Convertible'],
  'Mustang Mach-E': ['SUV'], 'Ranger': ['Truck'], 'Transit': ['Van'],
  'Transit Connect': ['Van'],
  // Genesis
  'Electrified G80': ['Sedan'], 'Electrified GV70': ['SUV'], 'G70': ['Sedan'],
  'G80': ['Sedan'], 'G90': ['Sedan'], 'GV60': ['SUV'], 'GV70': ['SUV'], 'GV80': ['SUV'],
  // GMC
  'Acadia': ['SUV'], 'Canyon': ['Truck'], 'Hummer EV': ['SUV', 'Truck'],
  'Sierra 1500': ['Truck'], 'Sierra 2500HD': ['Truck'], 'Sierra 3500HD': ['Truck'],
  'Terrain': ['SUV'], 'Yukon': ['SUV'], 'Yukon XL': ['SUV'],
  // Honda
  'Accord': ['Sedan'], 'Civic': ['Sedan', 'Hatchback'], 'CR-V': ['SUV'],
  'HR-V': ['SUV'], 'Odyssey': ['Minivan'], 'Passport': ['SUV'], 'Pilot': ['SUV'],
  'Prologue': ['SUV'], 'Ridgeline': ['Truck'],
  // Hyundai
  'Elantra': ['Sedan'], 'Ioniq 5': ['SUV'], 'Ioniq 6': ['Sedan'],
  'Kona': ['SUV'], 'Kona Electric': ['SUV'], 'Nexo': ['SUV'], 'Palisade': ['SUV'],
  'Santa Cruz': ['Truck'], 'Santa Fe': ['SUV'], 'Sonata': ['Sedan'],
  'Tucson': ['SUV'], 'Venue': ['SUV'],
  // Infiniti
  'Q50': ['Sedan'], 'Q60': ['Coupe'], 'QX50': ['SUV'], 'QX55': ['SUV'],
  'QX60': ['SUV'], 'QX80': ['SUV'],
  // Jaguar
  'E-Pace': ['SUV'], 'F-Pace': ['SUV'], 'F-Type': ['Coupe', 'Convertible'],
  'I-Pace': ['SUV'], 'XE': ['Sedan'], 'XF': ['Sedan'],
  // Jeep
  'Cherokee': ['SUV'], 'Compass': ['SUV'], 'Gladiator': ['Truck'],
  'Grand Cherokee': ['SUV'], 'Grand Cherokee 4xe': ['SUV'], 'Grand Cherokee L': ['SUV'],
  'Grand Wagoneer': ['SUV'], 'Renegade': ['SUV'], 'Wagoneer': ['SUV'],
  'Wrangler': ['SUV'], 'Wrangler 4xe': ['SUV'],
  // Kia
  'Carnival': ['Minivan'], 'EV6': ['SUV'], 'EV9': ['SUV'], 'Forte': ['Sedan'],
  'K5': ['Sedan'], 'Niro': ['SUV'], 'Niro EV': ['SUV'], 'Rio': ['Sedan'],
  'Seltos': ['SUV'], 'Sorento': ['SUV'], 'Soul': ['Hatchback'],
  'Sportage': ['SUV'], 'Stinger': ['Sedan'], 'Telluride': ['SUV'],
  // Land Rover
  'Defender': ['SUV'], 'Discovery': ['SUV'], 'Discovery Sport': ['SUV'],
  'Range Rover': ['SUV'], 'Range Rover Evoque': ['SUV'],
  'Range Rover Sport': ['SUV'], 'Range Rover Velar': ['SUV'],
  // Lexus
  'ES': ['Sedan'], 'GX': ['SUV'], 'IS': ['Sedan'], 'LC': ['Coupe', 'Convertible'],
  'LS': ['Sedan'], 'LX': ['SUV'], 'NX': ['SUV'], 'RC': ['Coupe'],
  'RX': ['SUV'], 'RZ': ['SUV'], 'TX': ['SUV'], 'UX': ['SUV'],
  // Lincoln
  'Aviator': ['SUV'], 'Corsair': ['SUV'], 'Nautilus': ['SUV'], 'Navigator': ['SUV'],
  // Lucid
  'Air': ['Sedan'],
  // Maserati
  'Ghibli': ['Sedan'], 'GranTurismo': ['Coupe'], 'Grecale': ['SUV'],
  'Levante': ['SUV'], 'Quattroporte': ['Sedan'],
  // Mazda
  'CX-30': ['SUV'], 'CX-5': ['SUV'], 'CX-50': ['SUV'], 'CX-70': ['SUV'],
  'CX-90': ['SUV'], 'Mazda3': ['Sedan', 'Hatchback'],
  'MX-5 Miata': ['Convertible'], 'MX-30': ['SUV'],
  // Mercedes-Benz
  'A-Class': ['Sedan'], 'AMG GT': ['Coupe', 'Convertible'], 'C-Class': ['Sedan'],
  'CLA': ['Sedan'], 'CLE': ['Coupe', 'Convertible'], 'E-Class': ['Sedan', 'Wagon'],
  'EQB': ['SUV'], 'EQE': ['Sedan', 'SUV'], 'EQS': ['Sedan', 'SUV'],
  'G-Class': ['SUV'], 'GLA': ['SUV'], 'GLB': ['SUV'], 'GLC': ['SUV'],
  'GLE': ['SUV'], 'GLS': ['SUV'], 'S-Class': ['Sedan'], 'SL': ['Convertible'],
  // MINI
  'Clubman': ['Wagon'], 'Convertible': ['Convertible'], 'Countryman': ['SUV'],
  'Hardtop': ['Hatchback'],
  // Mitsubishi
  'Eclipse Cross': ['SUV'], 'Mirage': ['Hatchback', 'Sedan'], 'Outlander': ['SUV'],
  'Outlander PHEV': ['SUV'], 'Outlander Sport': ['SUV'],
  // Nissan
  'Altima': ['Sedan'], 'Ariya': ['SUV'], 'Armada': ['SUV'], 'Frontier': ['Truck'],
  'Kicks': ['SUV'], 'Leaf': ['Hatchback'], 'Maxima': ['Sedan'], 'Murano': ['SUV'],
  'Pathfinder': ['SUV'], 'Rogue': ['SUV'], 'Sentra': ['Sedan'], 'Titan': ['Truck'],
  'Versa': ['Sedan'], 'Z': ['Coupe'],
  // Polestar
  'Polestar 2': ['Sedan'],
  // Porsche
  '718 Boxster': ['Convertible'], '718 Cayman': ['Coupe'], '911': ['Coupe', 'Convertible'],
  'Cayenne': ['SUV'], 'Macan': ['SUV'], 'Panamera': ['Sedan'], 'Taycan': ['Sedan'],
  // RAM
  '1500': ['Truck'], '2500': ['Truck'], '3500': ['Truck'], 'ProMaster': ['Van'],
  // Rivian
  'R1S': ['SUV'], 'R1T': ['Truck'],
  // Subaru
  'Ascent': ['SUV'], 'BRZ': ['Coupe'], 'Crosstrek': ['SUV'], 'Forester': ['SUV'],
  'Impreza': ['Sedan', 'Hatchback'], 'Legacy': ['Sedan'], 'Outback': ['SUV', 'Wagon'],
  'Solterra': ['SUV'], 'WRX': ['Sedan'],
  // Tesla
  'Model 3': ['Sedan'], 'Model S': ['Sedan'], 'Model X': ['SUV'], 'Model Y': ['SUV'],
  // Toyota
  '4Runner': ['SUV'], 'bZ4X': ['SUV'], 'Camry': ['Sedan'], 'Corolla': ['Sedan', 'Hatchback'],
  'Corolla Cross': ['SUV'], 'Crown': ['Sedan'], 'GR Corolla': ['Hatchback'],
  'GR Supra': ['Coupe'], 'GR86': ['Coupe'], 'Grand Highlander': ['SUV'],
  'Highlander': ['SUV'], 'Land Cruiser': ['SUV'], 'Mirai': ['Sedan'],
  'Prius': ['Hatchback'], 'Prius Prime': ['Hatchback'], 'RAV4': ['SUV'],
  'RAV4 Prime': ['SUV'], 'Sequoia': ['SUV'], 'Sienna': ['Minivan'],
  'Tacoma': ['Truck'], 'Tundra': ['Truck'], 'Venza': ['SUV'],
  // Volkswagen
  'Arteon': ['Sedan'], 'Atlas': ['SUV'], 'Atlas Cross Sport': ['SUV'],
  'Golf': ['Hatchback'], 'Golf GTI': ['Hatchback'], 'Golf R': ['Hatchback'],
  'ID.4': ['SUV'], 'ID.Buzz': ['Minivan'], 'Jetta': ['Sedan'], 'Jetta GLI': ['Sedan'],
  'Taos': ['SUV'], 'Tiguan': ['SUV'],
  // Volvo
  'C40 Recharge': ['SUV'], 'EX30': ['SUV'], 'EX90': ['SUV'], 'S60': ['Sedan'],
  'S90': ['Sedan'], 'V60': ['Wagon'], 'V90': ['Wagon'], 'XC40': ['SUV'],
  'XC40 Recharge': ['SUV'], 'XC60': ['SUV'], 'XC90': ['SUV'],
};

// Sorted list of makes for the dropdown
export const makes = Object.keys(vehicleData).sort();

// Get models for a given make
export const getModels = (make) => vehicleData[make] || [];

// Get applicable body types for a model (returns null if no restriction)
export const getBodyTypes = (model) => modelBodyTypes[model] || null;

export default vehicleData;
